export default "__VITE_ASSET__DeHgweyG__"